import React from "react";

import PlusSvg from "../../assets/images/icons/plus_gray.svg";

export const PlusGrayIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={PlusSvg}
        alt={alt || "Plus"}
    />
);
